<template>
  <div id="welcome">
    <sub-header :title="app_settings && app_settings.app_subtitle && firebase_config && firebase_config.projectId !== 'aram-demo'? app_settings.app_subtitle: ``"></sub-header>
    <!-- Web only views -->
    <div class="d-none d-md-block" id="web_home">
      <div id="banner" class style="width:100%;">
        <div class="container" id="bannercotainaer">
          <div class="row">
            <div class="col-sm-12">
              <div class="jumbotran">
                <div class="row">
                  <div class="col-sm-6 my-0 mt-4 py-0">
                    <template v-if="firebase_config && firebase_config.projectId === 'aram-demo'">
                      <div class="pt-4">
                        <picture>
                          <source srcset="/instances/aram-demo/img/outreach_logo.webp" type="image/webp"  width="300px" height="100px" class="mt-4" >
                          <source srcset="/instances/aram-demo/img/outreach_logo.png" type="image/png"  width="300px" height="100px" class="mt-4" >
                          <img src="/instances/aram-demo/img/outreach_logo.png" alt="Cognizant Outreach"  width="300px" height="100px" class="mt-4" >
                        </picture>
                      </div>
                    </template>
                    <template v-else>
                      <h1 v-if="app_settings && app_settings.app_title" class="mt-4 pt-4 pb-2">{{app_settings.app_title}}</h1>
                      <h1 v-else>Cognizant Assist</h1>
                      <h5 v-if="app_settings && app_settings.app_subtitle">{{app_settings.app_subtitle}}</h5>
                      <h5 v-else>Aspire to serve</h5>  
                      <template v-if="user && user.loggedIn">
                        <router-link to="/profile">
                          <button class="btn btn-sm mt-4 px-3 py-2">My Dashboard</button>
                        </router-link>
                      </template> 
                      <template v-else>
                        <router-link to="/register">
                          <button class="btn btn-sm mt-4 px-3 py-1">Signup</button>
                        </router-link>
                        <router-link to="/login">
                          <button class="btn btn-sm mt-4 mx-4 px-3 py-1">Login</button>
                        </router-link>
                      </template>
                    </template> 
                  </div>
                  <div class="col-sm-6 my-0 py-0 text-right logocontainer">
                    <img v-if="firebase_config && firebase_config.projectId === 'aram-demo'" class="p-0 my-2 my-4" :src="`/instances/${instance_id}/img/logo.png`" height="220px" width="440px"/>
                    <img v-else class="homepagelogo p-0 my-2" :src="`/instances/${instance_id}/img/logo.png`" height="280px" width="320px"/>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="container py-4" id="web-menu-container">
        <div class="row my-4">
          <div class="col-sm-4 text-center animated fadeIn">
            <div class="web-menu text-center">
              <router-link to="/need/support">
                <div id="web-menu-img-need-support" :style="{ 'background-image' : `url('/instances/${instance_id}/img/need_support.jpg')` }" class="img"></div>              
                <div class="link text-center m-3 p-2 px-4 btn">I Need Support</div>
              </router-link>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="web-menu text-center animated fadeIn">
              <router-link to="/can/support">
                <div id="web-menu-img-can-support" :style="{ 'background-image' : `url('/instances/${instance_id}/img/volunteering.jpg')` }"  class="img"></div>
                <div class="link text-center m-3 p-2 px-4 btn">I Can Support</div>
              </router-link>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="web-menu text-center animated fadeIn">
              <router-link to="/donate">
                <div id="web-menu-img-donate"  :style="{ 'background-image' : `url('/instances/${instance_id}/img/donate.jpg')` }" class="img"></div>
                <div class="link text-center m-3 p-2 px-4 btn">Donate</div>
              </router-link>
            </div>
          </div>
        </div>
      </div>
      <div class="container pb-4">
        <div class="row">
          <div class="col-sm-7">
            <div class="px-2">
              <MarkdownDisplay v-if="app_settings && app_settings.page_homepage" :text="app_settings.page_homepage" />
            </div>
          </div>
          <div class="col-sm-5">
            <div class="px-2 mb-4">
              <h4 class="text-primary mb-3">Contact Us</h4>
              <MarkdownDisplay v-if="app_settings && app_settings.page_contactus" :text="app_settings.page_contactus"/>
            </div>
            <div class="px-2 pt-4 mt-4">
              <h4 class="text-primary mb-3">Leave us a message</h4>
              <MessageForm />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Mobile Only views -->
    <div id="mobileonly" class="d-block d-md-none">
      <div v-if="firebase_config && firebase_config.projectId === 'aram-demo'">
        <div class="row animated slideInDown bg-primary">
          <div class="col-sm-12">
            <div class="text-center py-3 m-0">
              <picture>
                  <source srcset="/instances/aram-demo/img/outreach_logo.webp" type="image/webp"  width="170px" height="50px">
                  <source srcset="/instances/aram-demo/img/outreach_logo.png" type="image/png"  width="170px" height="50px">
                  <img src="/instances/aram-demo/img/outreach_logo.png" alt="Cognizant Outreach"  width="170px" height="50px">
              </picture>
            </div>
          </div>
        </div>
      </div>
      <div style="border-bottom:1px solid #cccccc;background:white;">
        <div class="row" v-if="user && user.loggedIn">
          <div class="col-sm-12 text-center py-2 my-2">
            <router-link to="profile">
              <span class="text-white btn btn-success mx-2 animated flipInX">My Dashboard</span>
            </router-link>
          </div>
        </div>
        <div class="row" v-else>
          <div class="col-sm-12 text-center py-2 my-2">
            <router-link to="login">
              <span class="text-white btn btn-success mx-2 animated flipInX">Login / Register</span>
            </router-link>
          </div>
        </div>
      </div>
      <div style="border-bottom:1px solid #cccccc;background:white;">
        <router-link to="/support-requests" v-if="user && user.data && (user.data.moderator || user.data.verifiedvolunteer)">
          <div class="row mobile-menu animated slideInRight delay-100ms">
            <div class="col-sm-12">
              <div>
                <i class="fa fa-folder-open text-primary mr-3 my-1"></i>
                <span class="ml-4">Who needs help</span>
                <span class="float-right">
                  <i class="fa fa-arrow-right"></i>
                </span>
              </div>
            </div>
          </div>
        </router-link>
        <router-link to="/need/support">
          <div class="row mobile-menu animated slideInRight delay-100ms">
            <div class="col-sm-12">
              <div>
                <i class="fa fa-support text-primary mr-3 my-1"></i>
                <span class="ml-4">I Need Support</span>
                <span class="float-right">
                  <i class="fa fa-arrow-right"></i>
                </span>
              </div>
            </div>
          </div>
        </router-link>
        <router-link to="/can/support" v-if="user && user.data && user.data.verifiedvolunteer">
          <div class="row mobile-menu animated slideInRight delay-200ms">
            <div class="col-sm-12">
              <i class="fa fa-user text-primary mr-3 my-1"></i>
              <span class="ml-4">My Account</span>
              <span class="float-right">
                <i class="fa fa-arrow-right"></i>
              </span>
            </div>
          </div>
        </router-link>
        <router-link to="/can/support" v-else>
          <div class="row mobile-menu animated slideInRight delay-200ms">
            <div class="col-sm-12">
              <i class="fa fa-heart text-primary mr-3 my-1"></i>
              <span class="ml-4">I Can Support / Volunteer</span>
              <span class="float-right">
                <i class="fa fa-arrow-right"></i>
              </span>
            </div>
          </div>
        </router-link>
        <router-link to="/donate">
          <div class="row mobile-menu animated slideInRight delay-300ms">
            <div class="col-sm-12">
              <i class="fa fa-gift text-primary mr-3 my-1"></i>
              <span class="ml-4">Donate</span>
              <span class="float-right">
                <i class="fa fa-arrow-right"></i>
              </span>
            </div>
          </div>
        </router-link>
        <router-link to="/contact">
          <div class="row mobile-menu animated slideInRight delay-200ms">
            <div class="col-sm-12">
              <i class="fa fa-phone text-primary mr-3 my-1"></i>
              <span class="ml-4">Contact</span>
              <span class="float-right">
                <i class="fa fa-arrow-right"></i>
              </span>
            </div>
          </div>
        </router-link>
        <router-link to="/contact/moderator">
          <div class="row mobile-menu pb-4 animated slideInRight delay-100ms">
            <div class="col-sm-12">
              <i class="fa fa-envelope text-primary mr-3 my-1"></i>
              <span class="ml-4">Send us a message</span>
              <span class="float-right">
                <i class="fa fa-arrow-right"></i>
              </span>
            </div>
          </div>
        </router-link>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
const MarkdownDisplay = () => import(/* webpackChunkName: "MarkdownDisplay" */ "@/components/MarkdownDisplay");
import MessageForm from "@/views/messages/components/MessageForm";
import { instance_id , firebase_config } from "@/config/config";
export default {
  components: {
    MarkdownDisplay,
    MessageForm
  },
  data() {
    return {
      instance_id,
      breadcrumbs: [{ text: "Home", active: true }],
      error: null,
      status: null
    };
  },
  created(){
    this.firebase_config = firebase_config
  },
  computed: {
    ...mapGetters({
      user: "user",
      app_settings: "app_settings"
    })
  }
};
</script>
<style lang="scss" scoped>
/deep/ {
  h1, h2, h3, h4, h5, h6 {
    color: rgb(0,51,160);
  }
  img {
    max-width: 100% !important;
  }
}
</style>